import { FormControl } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledFormControl = styled(FormControl)({
  display: "flex",
  width: "100%"
})
